/**
 * The postal mail reads (NT-14, plan 2026-10-22-postal-mail-postgrid): ordinary catalog GETs; every
 * write (the staff letter upload and mailing, cancel, advance a test letter) is the named exception
 * in `mail-writes.ts`. Split out of `catalog.ts` on file-size grounds only.
 *
 * The list sits AT the prefix (filters `status`, `purpose`, `company_id`, `search` and paging), and
 * `destinations` (the registered IRS mail addresses, for the staff tool's picker) is the one static
 * GET beside the id; `uploads` is the other static word there, a POST. The id is the API's own shape
 * (letters, digits and `_ . : -`, never a leading dot, so never a dot segment). `cancel` and
 * `progress` sit BELOW the id and are POST-only upstream, so nothing deeper is declared and neither
 * is reachable as a GET; `upstream-siblings.ts` records the static words beside the id.
 */
import type { ReadRoute } from "./catalog";

export const MAIL_READ_ROUTES: readonly ReadRoute[] = [
  {
    path: "/api/admin/mail",
    query: ["status", "purpose", "company_id", "search", "page", "pageSize"],
  },
  { path: "/api/admin/mail/destinations", query: [] },
  // `%` is in the class because the detail query `encodeURIComponent`s the id and every mail id
  // carries `:` (`staff:<company>:<destination>:<hash>`), which arrives as `%3A`; the first
  // character is never `.` or `%`, so no spelling of `.` or `..` fits (the contacts entry's rule).
  { path: "/api/admin/mail/:id{[A-Za-z0-9_:-][A-Za-z0-9_.:%-]*}", query: [] },
];
